import { render, staticRenderFns } from "./ProfileSectionBusyOverlay.vue?vue&type=template&id=3a476a55&scoped=true"
import script from "./ProfileSectionBusyOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSectionBusyOverlay.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileSectionBusyOverlay.vue?vue&type=style&index=0&id=3a476a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a476a55",
  null
  
)

export default component.exports